import { authConsts } from "../types/auth";
import {
  UzytkownikWidok,
  uzytkownicyConsts,
  UzytkownicyAction,
} from "../types/uzytkownicy";

export interface UzytkownicyState {
  lista: UzytkownikWidok[];
  browseError: string;
  editError: string;
}

const initialState: UzytkownicyState = {
  lista: [],
  browseError: "",
  editError: "",
};

export default function organizacje(
  state = initialState,
  action: UzytkownicyAction
): UzytkownicyState {
  switch (action.type) {
    case uzytkownicyConsts.UZYTKOWNICY_PRZEGLADAJ_SUCCESS:
      return { ...state, lista: action.lista, browseError: "" };
    case uzytkownicyConsts.UZYTKOWNICY_PRZEGLADAJ_FAILURE:
    case uzytkownicyConsts.UZYTKOWNICY_USUN_FAILURE:
      return { ...state, browseError: action.error };
    case uzytkownicyConsts.UZYTKOWNICY_DAJ_FAILURE:
    case uzytkownicyConsts.UZYTKOWNICY_ZAPROS_FAILURE:
    case uzytkownicyConsts.UZYTKOWNICY_EDYTUJ_FAILURE:
      return { ...state, editError: action.error };
    case uzytkownicyConsts.CLEAR_EDIT_ERROR:
      return { ...state, editError: "" };
    case authConsts.LOGOUT:
      return initialState;
    default:
      return state;
  }
}
